module.exports = __webpack_public_path__ + "static/img/egg_r_16.dac9648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_16.png
// module id = RsJi
// module chunks = 1